import "react-app-polyfill/ie11";
import "core-js/features/array";
import "core-js/features/number";
import "core-js/features/object/entries";
import "core-js/features/string/includes";
import "core-js/features/string/starts-with";

import "typeface-montserrat";
import "./index.scss";

import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from "react-router-dom";
import {Provider} from 'react-redux';

import App from './App';

import configureStore from "./configureStore";
import {PersistGate} from "redux-persist/integration/react";
import 'bootstrap/dist/css/bootstrap.min.css';
import GoogleAnalytics from "./components/common/googleAnalytics/GoogleAnalytics";

const {store, persistor} = configureStore({});

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App/>
        <GoogleAnalytics />
      </PersistGate>
    </Provider>
  </Router>,
  document.getElementById('root')
)
